import {t} from 'i18next';
import {useBookingState} from '../store';
import {formatDateToReadableString} from '../helpers';
import {Trans} from 'react-i18next';
import {investigationOfImpedimentsLink} from '../utils/constants';
import {useEffect} from 'react';
import {UaLink} from 'uppsala.ui.react';

const ConfirmationPage = () => {
  const state = useBookingState((state) => state);

  useEffect(() => {
    state.setSelectedMonthYear('');
    state.setWeddingOccasionId('');
  }, []);

  return (
    <div>
      <h1>{t('booking.bookingConfirmationCompleted')}</h1>
      <p style={{fontWeight: 'bold', marginBottom: '1rem'}}>
        {t('booking.bookingConfirmationSelectedDateAndTime', {
          locationName: state.location,
          dateTime: formatDateToReadableString(new Date(state.weddingOccasionTime)),
        })}
      </p>
      <p className="whitespace-pre-line">
        <Trans
          i18nKey={'booking.investigationOfImpedimentsInfo'}
          values={{linkText: t('booking.uploadInvestigationOfImpediments')}}
          components={{
            1: (
              <UaLink
                text={t('booking.uploadInvestigationOfImpediments')}
                link={investigationOfImpedimentsLink}
                target="_blank"
              />
            ),
          }}
        />
      </p>
    </div>
  );
};

export default ConfirmationPage;
